import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaceAccounts from "common/datahooks/useWorkspaceAccounts";

import { useActiveConversationContext } from "../context/ActiveConversationContext";
import { useNewConversation } from "./useNewConversation";

export default function useActiveConversationOwnerAccount() {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { workspaceAccounts } = useWorkspaceAccounts(workspaceId);
  const { activeConversation } = useActiveConversationContext();
  const { newConversation } = useNewConversation();

  const ownerAccountId = activeConversation
    ? activeConversation.owner
    : newConversation.owner;

  const ownerAccount = workspaceAccounts?.find(
    ({ id }) => id === ownerAccountId,
  );

  return { ownerAccountId, ownerAccount };
}
